import { useState, useEffect } from 'react';

export const useTypingAnimation = (
  sentences: string[],
  typeSpeed: number = 100,
  deleteSpeed: number = 50,
  delayAfterTyping: number = 1500
) => {
  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (sentences.length === 0) {
      return;
    }
    
    const currentSentence = sentences[index];

    const handleTyping = () => {
      if (isDeleting) {
        if (text.length > 0) {
          setText((prev) => prev.slice(0, -1));
        } else {
          setIsDeleting(false);
          setIndex((prev) => (prev + 1) % sentences.length);
        }
      } else {
        if (text.length < currentSentence.length) {
          setText((prev) => prev + currentSentence.charAt(prev.length));
        } else {
          setTimeout(() => setIsDeleting(true), delayAfterTyping);
        }
      }
    };

    const typingTimeout = setTimeout(handleTyping, isDeleting ? deleteSpeed : typeSpeed);

    return () => clearTimeout(typingTimeout);
  }, [text, index, isDeleting, sentences, typeSpeed, deleteSpeed, delayAfterTyping]);

  return text;
};